import { useNavigate } from 'react-router-dom'
import { Doughnut } from 'react-chartjs-2'
import { FaArrowRight, FaChartPie, FaFileAlt, FaPlus, FaRegFileAlt } from 'react-icons/fa'
import { brandPalette, formatNumberGBP } from '../chartHelpers'
import styles from '../styles.module.scss'

const CATEGORY_COUNTS: Array<{ label: string; count: number }> = [
    { label: 'Introducer Reports', count: 7 },
    { label: 'General Reports', count: 7 },
    { label: 'Woodville', count: 3 },
    { label: 'LOA Reports', count: 5 },
]

const POPULAR_REPORTS: Array<{ title: string; description: string; category: string }> = [
    {
        title: 'All Introducer Claims',
        description: 'Complete overview of all introducer claims data.',
        category: 'Introducer Reports',
    },
    {
        title: 'Duplicate Policy Number Report',
        description: 'Surface duplicate policy numbers across introducers.',
        category: 'Introducer Reports',
    },
    {
        title: 'Daily Policy Number Report',
        description: 'Yesterday\u2019s policy number activity.',
        category: 'General Reports',
    },
    {
        title: 'FOA v2 Report',
        description: 'Refreshed Form of Authority data.',
        category: 'LOA Reports',
    },
]

export const ReportLinksSection = () => {
    const navigate = useNavigate()

    const doughnutData = {
        labels: CATEGORY_COUNTS.map((c) => c.label),
        datasets: [
            {
                data: CATEGORY_COUNTS.map((c) => c.count),
                backgroundColor: brandPalette.slice(0, CATEGORY_COUNTS.length),
                borderColor: '#ffffff',
                borderWidth: 2,
            },
        ],
    }

    const totalReports = CATEGORY_COUNTS.reduce((sum, c) => sum + c.count, 0)

    return (
        <section className={styles.sectionCard}>
            <div className={styles.sectionHeader}>
                <div>
                    <h2 className={styles.sectionTitle}>
                        <FaFileAlt /> Report Links
                    </h2>
                    <p className={styles.sectionSubtitle}>
                        Build a custom report or jump to the {formatNumberGBP(totalReports)} pre-built downloads.
                    </p>
                </div>
                <div className={styles.sectionActions}>
                    <button
                        className={styles.primaryAction}
                        onClick={() => navigate('/report-links#custom-report')}
                    >
                        <FaPlus /> Build a Custom Report
                    </button>
                    <button className={styles.secondaryAction} onClick={() => navigate('/report-links')}>
                        View All Reports <FaArrowRight />
                    </button>
                </div>
            </div>

            <div className={styles.chartsRow}>
                <div className={styles.chartCard}>
                    <div className={styles.chartHeader}>
                        <FaChartPie /> Reports by Category
                    </div>
                    <div className={styles.chartCanvas}>
                        <Doughnut
                            data={doughnutData}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { position: 'right', labels: { boxWidth: 12 } },
                                    tooltip: {
                                        callbacks: {
                                            label: (ctx) => `${ctx.label}: ${ctx.parsed} reports`,
                                        },
                                    },
                                },
                                cutout: '60%',
                            }}
                        />
                    </div>
                </div>

                <div className={styles.popularList}>
                    <div className={styles.popularListTitle}>Popular reports</div>
                    {POPULAR_REPORTS.map((report) => (
                        <button
                            key={report.title}
                            className={styles.popularRow}
                            onClick={() => navigate('/report-links')}
                        >
                            <FaRegFileAlt className={styles.popularIcon} />
                            <div className={styles.popularInfo}>
                                <div className={styles.popularTitle}>{report.title}</div>
                                <div className={styles.popularDescription}>{report.description}</div>
                            </div>
                            <span className={styles.popularCategory}>{report.category}</span>
                            <FaArrowRight className={styles.recentArrow} />
                        </button>
                    ))}
                </div>
            </div>
        </section>
    )
}
